import React, { useState } from "react";

import CreateRecordButton from "./CreateRecordButton";
import EguOutSourcingMaterialReturnRegisterDialog from "../dialogTypes/EguOutSourcingMaterialReturnRegisterDialog";

function EguOutSourcingMaterialReturnRegisterButton(props) {
    const { id, refresh, schema, onSuccess, customizeErrorMsgCallback, ...others } = props;

    const [open, setOpen] = useState(false);

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onRegisterSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        if (refresh) {
            refresh.refresh();
        }
    };

    return (
        <React.Fragment>
            <CreateRecordButton id={id} onClick={onOpen} {...others} />
            <EguOutSourcingMaterialReturnRegisterDialog
                id={id + "-register-dialog"}
                schema={schema}
                open={open}
                onClose={onClose}
                onSuccess={onRegisterSuccess}
            />
        </React.Fragment>
    );
}

export default EguOutSourcingMaterialReturnRegisterButton;
